export default __webpack_public_path__ + "static/media/circle-date.4c5a6c55.svg";